import React, { useEffect, useState, useRef } from 'react';
import { Flex, SVGPureIcon } from '@/ui';
import './index.scss';

const ScrollToTop = (props) => {
  const { className, style, onClick } = props;

  return (
    <Flex
      center
      className={[
        "scroll-top",
        "size-48px flex-shrink-0 z-1000",
        "border-1px border-[rgba(0,0,0,0.1)] rounded-full",
        "group cursor-pointer overflow-hidden",
        className
      ]}
      style={style}
      onClick={() => {
        onClick && onClick()
      }}
    >
      <Flex center column>
        <SVGPureIcon 
          name="upper"
          size={18}
          className="cursor-pointer text-[rgba(0,0,0,0.5)] group-hover:text-[#000] arrow"
        />
        <span className="text-[#000] text-13px srcoll-text">回顶部</span>
      </Flex>
    </Flex>
  )
}

export default ScrollToTop;